<template>
  <iframe
    :src="viewerSrc"
    :class="props.class"
    :title="props.title || $t('pdf.pdfPreview')"
    type="application/pdf"
    scrolling="no"
    frameborder="0"
  ></iframe>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { PdfViewerProps } from '@/types/pdf';

const props = defineProps<PdfViewerProps>();

const viewerSrc = computed(() => {
  if (!props.hideUi) {
    return props.src;
  }

  const hideUiParams = 'page=1&zoom=page-width&view=FitH&toolbar=0&navpanes=0&scrollbar=0';

  if (!props.src.includes('#')) {
    return `${props.src}#${hideUiParams}`;
  }

  return `${props.src}&${hideUiParams}`;
});
</script>

<style scoped>
iframe {
  border: 0;
  overflow: hidden;
}
</style>
